/**
 * @authors wangxu (you@example.org)
 * @date    公共方法
 * @version $Id$
 */

import Vue from 'vue'

let vm = new Vue()

// 深拷贝
export function assign (dest, ...srcs) {
  srcs.reverse().forEach(src => {
    for (const k in src) {
      if (src.hasOwnProperty(k)) {
        dest[k] = src[k]
      }
    }
  })
  return dest
}
/**
 * 提示信息
 * @String msg     提示的文字内容
 * @String method  提示类型 info | error | success | warning | loading
 */
export function showMsg (msg = '出错了！请重试') {
  vm.$message.closeAll()
  vm.$message.error(msg)
}

// 删除数组某一项
export function removeArrItem (arr, item) {
  var index = arr.indexOf(item)
  if (index > -1) {
    arr.splice(index, 1)
  }
}
// 获取cookie信息
export function getCookie (name) {
  var arr
  var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  arr = document.cookie.match(reg)
  if (arr) {
    return arr[2]
  } else {
    return ''
  }
}
/**
 * @description 数组查重, 会过滤数据为空项
 * @param {arr} 数组
 */
export function isArrRepeat (arr) {
  var hash = {}
  for (var i in arr) {
    if (hash[arr[i]]) {
      return true
    }
    hash[arr[i]] = true
  }
  return false
}

/**
 * @description 毫秒数转日期
 * @param {string} 毫秒数
 * @param {string} 格式 'yyyy-MM-dd hh:mm:ss'
 */
export function formatDate (time, fmt) {

  var date = new Date(time)
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
   
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
   
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
    }
  }
   
  return fmt
}

/**
 * @description Date转日期
 * @param {Date} 日期
 * @param {string} 格式 'yyyy-MM-dd hh:mm:ss'
 */

// Date转为yyyy-MM-dd hh:mm:ss
export function formDateStr(date, fmt) {
  return formatDate(date.getTime(), fmt);
}

/**
 * @description 获取当天具体指定时间
 * @param {number} 时
 * @param {number} 分
 * @param {number} 秒
 * @param {number} 毫秒
 */

// 获取当天具体指定时间
export function getCurrentDate(h, m, s, ms) {
  return new Date(new Date(new Date().getTime()).setHours(h, m, s, ms))
}

/**
 * @description 倒计时
 * @param {string} 秒数
 */
export function timeSown (second) {

  let str = ''
  if(second && second > 0) {
    let h = Math.floor(second/(60*60))
    let leftS = second - h*60*60
    let m = Math.floor(leftS/60)
    let s = second - (h*60*60) - (m*60)

    h = h>9 ? h : '0'+h
    m = m>9 ? m : '0'+m
    s = s>9 ? s : '0'+s
    str = h +':'+m+':'+s
  }
   
  return str
}



// WEBPACK FOOTER //
// ./src/api/utils.js